export interface Initializer {
    initialize(): Promise<unknown> | void;
}

export function initializerFactory(
    initializer: Initializer
): () => void | Promise<unknown> {
    return () => initializer.initialize();
}
